import axios from '../utils/axios'

// 获取排行榜列表
export function getAgentRankList(params) {
  return axios.post('/user/apiUserAh5Service/getRankList', params)
}

export function getRankSetting(params) {
  return axios.post('/user/apiUserAh5Service/getRankSetting', params)
}
